import { Box } from "@chakra-ui/react";
import React from "react";
import Projects from "../Components/Projects";
import Blogs from "../Components/Blogs";

const BlogsPage = () => {
  return (
    <Box
      as="main"
      w="full"
      h="full"
      pos="relative"
      boxSizing="border-box"
      my="8"
      px="8"
    >
      <Blogs />
    </Box>
  );
};

export default BlogsPage;
